import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '#02184D',
    pageBackground: '#F0FB96',
  },
  fonts: {
    body: fontStacks.cabinet.value,
    heading: fontStacks.cabinet.value,
  },
});

export const morning = createTheme({ ...mergedTokens });
